import { render, staticRenderFns } from "./QRLoginPage.vue?vue&type=template&id=dc7427a4&scoped=true&"
import script from "./QRLoginPage.vue?vue&type=script&lang=js&"
export * from "./QRLoginPage.vue?vue&type=script&lang=js&"
import style0 from "./QRLoginPage.vue?vue&type=style&index=0&id=dc7427a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7427a4",
  null
  
)

export default component.exports